// extracted by mini-css-extract-plugin
module.exports = {"upload":"drag-upload_upload__yYRTA"};